/**
 * Shared product types data used across ProductLine (Home) and ProductsPage.
 * ProductsPage is the source of truth — edit here and both pages update automatically.
 */

export const productTypesData = {
  ru: {
    title: 'Виды панелей GIPSOVINIL.KZ',
    types: [
      {
        name: 'Гипсовиниловые панели на основе гипсокартона',
        description: 'Универсальное решение на основе гипсокартона для учебных, административных, медицинских и общественных пространств.',
        specs: ['Класс: КМ2, Г1'],
        color: 'bg-blue-300',
        link: 'gkl',
        image: '/images/gkl_panel.png'
      },
      {
        name: 'Панели «Комфорт» на основе влагостойкого гипсокартона',
        description: 'Ударопрочный и влагостойкий гипсокартон с огнестойким картоном, армированный стекловолокном. Для отделки ЖК, бассейнов.',
        specs: ['Класс: КМ1, Г1'],
        color: 'bg-[#8b4444]',
        link: 'comfort',
        image: '/images/comfort_panel.png'
      },
      {
        name: 'Панели на основе стекломагниевого листа',
        description: 'На основе стекломагниевого листа: высокая огнестойкость, влагостойкость и прочность. Для спортзалов, промышленных объектов.',
        specs: ['Класс: КМ1, Г1'],
        color: 'bg-[#061d36]',
        link: 'sml',
        image: '/images/sml_panel.png'
      }
    ],
    more: 'Подробнее'
  },
  kz: {
    title: 'GIPSOVINIL.KZ панель түрлері',
    types: [
      {
        name: 'ГКЛ негізіндегі гипсвинил панельдер',
        description: 'Оқу, әкімшілік, медициналық кеңістіктер үшін әмбебап шешім.',
        specs: ['Класс: КМ2, Г1'],
        color: 'bg-blue-300',
        link: 'gkl',
        image: '/images/gkl_panel.png'
      },
      {
        name: 'Комфорт панельдері',
        description: 'Соққыға төзімді және ылғалға төзімді гипсокартон, отқа төзімді картонмен, шыны талшықпен армирленген. ТК, бассейндерді әрлеу үшін.',
        specs: ['Класс: КМ1, Г1'],
        color: 'bg-[#8b4444]',
        link: 'comfort',
        image: '/images/comfort_panel.png'
      },
      {
        name: 'Шыны магнезит парағы негізіндегі панельдер',
        description: 'Жоғары отқа төзімділік. Спорт залдары, өндірістік объектілер үшін.',
        specs: ['Класс: КМ1, Г1'],
        color: 'bg-[#061d36]',
        link: 'sml',
        image: '/images/sml_panel.png'
      }
    ],
    more: 'Толығырақ'
  },
  en: {
    title: 'GIPSOVINIL.KZ Panel Types',
    types: [
      {
        name: 'Gypsum-vinyl panels based on drywall',
        description: 'Universal solution for educational, administrative, medical and public spaces.',
        specs: ['Class: KM2, G1'],
        color: 'bg-blue-300',
        link: 'gkl',
        image: '/images/gkl_panel.png'
      },
      {
        name: 'Comfort Panels',
        description: 'Impact-resistant and moisture-resistant drywall with fire-resistant cardboard, reinforced with fiberglass. For residential complexes and pools.',
        specs: ['Class: KM1, G1'],
        color: 'bg-[#8b4444]',
        link: 'comfort',
        image: '/images/comfort_panel.png'
      },
      {
        name: 'Panels based on magnesium oxide board',
        description: 'High fire resistance, moisture resistance and strength. For gyms, industrial facilities.',
        specs: ['Class: KM1, G1'],
        color: 'bg-[#061d36]',
        link: 'sml',
        image: '/images/sml_panel.png'
      }
    ],
    more: 'Learn more'
  },
  ar: {
    title: 'أنواع ألواح GIPSOVINIL.KZ',
    types: [
      {
        name: 'ألواح جبسوفينيلية على أساس ألواح الجبس',
        description: 'حل شامل للفضاءات التعليمية والإدارية والطبية والعامة.',
        specs: ['الفئة: KM2, G1'],
        color: 'bg-blue-300',
        link: 'gkl',
        image: '/images/gkl_panel.png'
      },
      {
        name: 'ألواح «كومفورت» على أساس ألواح الجبس المقاومة للرطوبة',
        description: 'ألواح جبس مقاومة للصدمات والرطوبة مع كرتون مقاوم للحريق، مسلحة بالألياف الزجاجية. لتشطيب المجمعات السكنية وحمامات السباحة.',
        specs: ['الفئة: KM1, G1'],
        color: 'bg-[#8b4444]',
        link: 'comfort',
        image: '/images/comfort_panel.png'
      },
      {
        name: 'ألواح على أساس صفائح أكسيد المغنيسيوم',
        description: 'مقاومة عالية للحريق والرطوبة والقوة. للصالات الرياضية والمرافق الصناعية.',
        specs: ['الفئة: KM1, G1'],
        color: 'bg-[#061d36]',
        link: 'sml',
        image: '/images/sml_panel.png'
      }
    ],
    more: 'التفاصيل'
  }
};
